<template>
  <div class="drawer__header" data-js="get-height">
    <v-layout align-center justify-start>
      <v-btn
        v-if="history.length > 1"
        icon
        @click="goBack"
      >
        <v-icon color="gray-6">keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">{{ $t(`${namespace}.title`) }}</v-flex>
    </v-layout>

    <div>
      <v-menu
        v-if="
          hasRole('costCenter', 'ROLE_PUT_COSTCENTER_ID') ||
          hasRole('costCenter', 'ROLE_PUT_COSTCENTER_ID_ADDTOALLEMPLOYEES') ||
          hasRole('costCenter', 'ROLE_DELETE_COSTCENTER_ID')
        "
        offset-y
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="btn--more_vertical"
            icon
          >
            <v-icon color="gray-6">more_vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-if="hasRole('costCenter', 'ROLE_PUT_COSTCENTER_ID')"
            @click="$router.push({
              name: 'CostCenter',
              params: { type: 'editar', id: data.id }
            })"
          >
            <v-list-item-title>
              {{ $t(`${namespace}.editCostCenter`) }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="hasRole('costCenter', 'ROLE_PUT_COSTCENTER_ID')"
            @click="handleTemporaryDisabled"
          >
            <v-list-item-title>
              {{
                costCenterTemporaryDisabled
                  ? $t(`${namespace}.enableCostCenter`)
                  : $t(`${namespace}.disabledCostCenter`)
              }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="hasRole('costCenter', 'ROLE_PUT_COSTCENTER_ID_ADDTOALLEMPLOYEES')"
            @click="handleAddCostCenterToAllEmployees"
          >
            <v-list-item-title>
              {{ $t(`${namespace}.addCostCenterToAllEmployees`) }}
            </v-list-item-title>
          </v-list-item>

          <v-divider
            v-if="
              hasRole('costCenter', 'ROLE_DELETE_COSTCENTER_ID') &&
              hasRole('costCenter', 'ROLE_PUT_COSTCENTER_ID_ADDTOALLEMPLOYEES')
            "
          />

          <v-list-item
            v-if="hasRole('costCenter', 'ROLE_DELETE_COSTCENTER_ID')"
            @click="openSingleDeleteDialog"
          >
            <v-list-item-title>
              {{ $t(`${namespace}.deleteCostCenter`) }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn icon @click="close()">
        <v-icon color="gray-6">close</v-icon>
      </v-btn>
    </div>

    <!-- TODO: -->
    <SingleDeleteDialog
      v-if="false"
      :visible="singleDeleteDialog"
      :item="data"
      @close="closeSingleDeleteDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SingleDeleteDialog from 'components/pages/costCenters/dialogs/SingleDeleteDialog'
import { hasRole } from 'utils/functions'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    data: {
      type: Object,
      required: true
    }
  },
  components: {
    SingleDeleteDialog
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims,
      costCenterTemporaryDisabled: ({ globalDrawer }) => globalDrawer.costCenterTemporaryDisabled
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.costCenter.header',
      singleDeleteDialog: false,
      temporaryDisabledTemp: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show',
      setCostCenterTemporaryDisabled: 'globalDrawer/set'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    async handleTemporaryDisabled () {
      try {
        const temporaryDisabled = !this.data.temporaryDisabled

        await this.$apiService.updateCostCenter({
          ...this.data,
          temporaryDisabled
        })

        this.showAlert({
          type: 'success',
          message: temporaryDisabled
            ? this.$t('Components.CostCenterForm.disableCostCenterMonthSuccess')
            : this.$t('Components.CostCenterForm.enabledCostCenterMonthSuccess')
        })

        this.setCostCenterTemporaryDisabled({
          costCenterTemporaryDisabled: temporaryDisabled
        })

        this.$emit('reload')
      } catch (error) {
        catchError(error)

        if (error.response.data && error.response.data.errors) {
          const key = Object.keys(error.response.data.errors)[0]
          let msg

          if (key === 'name') {
            msg = this.$t('Components.CostCenterForm.costCenteRequiredMessage')
            return this.showAlert({ type: 'error', message: msg })
          }

          if (key === 'companyId') {
            msg = this.$t('Components.CostCenterForm.selectedACompany')
            return this.showAlert({ type: 'error', message: msg })
          }

          this.showAlert({
            type: 'error',
            message: this.temporaryDisabled
              ? this.$t('Components.CostCenterForm.enabledCostCenterMonthError')
              : this.$t('Components.CostCenterForm.disableCostCenterMonthError')
          })
        }

        this.showAlert({
          type: 'error',
          message: this.temporaryDisabled
            ? this.$t('Components.CostCenterForm.disableCostCenterMonthError')
            : this.$t('Components.CostCenterForm.enabledCostCenterMonthError')
        })
      }
    },

    async handleAddCostCenterToAllEmployees () {
      try {
        await this.$apiService.addToAllEmployees(this.data.id)
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.addToAllEmployeesSuccess`)
        })
      } catch (error) {
        catchError(error)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.addToAllEmployeesError`)
        })
      }
    },

    openSingleDeleteDialog () {
      this.singleDeleteDialog = true
    },

    closeSingleDeleteDialog (reload) {
      this.singleDeleteDialog = false
      reload && this.close(reload)
    }
  }
}
</script>
